import './textarea.scss'
import classNames from 'classnames'

export default function Textarea({ label, ...inputProps }) {
    const [value, setValue] = React.useState(inputProps.value || '')
    const [showError, setShowError] = React.useState(false)

    const onInputChange = e => {
        setValue(e.target.value)
        inputProps.onChange && inputProps.onChange(e.target.value)

        if (inputProps.required && e.target.value.trim().length === 0) {
            setShowError(true)
            e.preventDefault()
        }
        setShowError(false)
    }

    const className = classNames('textarea', {
        'is-active': value,
    })

    return (
        <div className={className}>
            <textarea
                {...inputProps}
                rows={inputProps.rows || '5'}
                className={`textarea__input ${inputProps.textareaClassName}`}
                onChange={onInputChange}></textarea>
            <label className={`textarea__label ${inputProps.labelClassName}`}>{label}</label>
            {showError && (
                <span className="text-small text-red d-flex mb-4">
                    <T>input.required.error.message</T>
                </span>
            )}
        </div>
    )
}
